var merge = require('webpack-merge')
var prodEnv = require('./prod.env')

module.exports = merge(prodEnv, {
  env: 'development',
  successRedirectionFallback: "http://localhost:8081/#/admin",
  apiUrl: 'http://localhost:8080', // Local seulement
  authConfig: {
    sessionTokenCookieDomain: "localhost",
    loginUrl: "http://localhost:8081/#/login",
    authUrl: "http://localhost:8080/v2/auth/token"
  }
})
